import React from "react";
import './DescriptionBox.css'

const DescriptionBox=()=>{
    return(
        <div className="descriptionbox">
<div className="descriptionbox-navigator">
    <div className="descriptionbox-nav-box">Description</div>
   
</div>
<div className="descriptionbox-description">
    <p>An e-commerce website is an online platform that facilitates the buying and selling of goods or services over the internet. It enables businesses to reach a global audience, operate 24/7, and conduct transactions securely.</p>
    <p>At its core, an e-commerce website provides a user-friendly platform that empowers consumers to explore a vast array of products and services from the comfort of their own homes or on the go. Through intuitive navigation, robust search functionalities, and personalized recommendations, users can easily discover and purchase items that meet their needs and preferences.</p>
</div>
        </div>
    )
}

export default DescriptionBox;